<template>
  <v-navigation-drawer
    :mobile-breakpoint="customMobileBreakpoint"
    expand-on-hover
    color="primary"
    absolute
    style="z-index: 3"
  >
    <v-divider></v-divider>

    <v-list nav dense v-for="item in items" :key="item.id">
      <v-list-item link :to="item.router" exact>
        <v-list-item-icon>
          <v-icon color="white" dense class="mx-auto">{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-title style="color: white">
          {{ item.text }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  data() {
    return {
      customMobileBreakpoint: 300,
      items: [
        {
          text: "Gestion Empleados",
          icon: "fa-arrow-left",
          id: 7,
          router: "/gestionEmpleados",
        },
        {
          text: "Empleado",
          icon: "fa-user",
          id: 8,
          router: `/gestionEmpleados/info/${localStorage.getItem("empId")}`,
        },
        {
          text: "Pautas",
          icon: "fa-handshake",
          id: 1,
          router: `/gestionEmpleados/info/${localStorage.getItem(
            "empId"
          )}/Pautas`,
        },
        {
          text: "Grupos",
          icon: "fa-users",
          id: 2,
          router: `/gestionEmpleados/info/${localStorage.getItem(
            "empId"
          )}/Grupos`,
        },
        {
          text: "Horarios",
          icon: "mdi-file-clock",
          id: 3,
          router: `/gestionEmpleados/info/${localStorage.getItem(
            "empId"
          )}/Horarios`,
        },
        {
          text: "Modelos",
          icon: "fa-tag",
          id: 4,
          router: `/gestionEmpleados/info/${localStorage.getItem(
            "empId"
          )}/Modelos`,
        },
        {
          text: "Atributos",
          icon: "fa-list",
          id: 5,
          router: `/gestionEmpleados/info/${localStorage.getItem(
            "empId"
          )}/Atributos`,
        },
        {
          text: "Tarjetas",
          icon: "fa-id-card",
          id: 6,
          router: `/gestionEmpleados/info/${localStorage.getItem(
            "empId"
          )}/Tarjetas`,
        },
        {
          text: "Saldos en cuenta",
          icon: "fa-file-invoice",
          id: 9,
          router: `/gestionEmpleados/info/${localStorage.getItem(
            "empId"
          )}/Saldos`,
        },
        {
          text: "Relojes",
          icon: "fa-clock",
          id: 10,
          router: `/gestionEmpleados/info/${localStorage.getItem(
            "empId"
          )}/Relojes`,
        },
        {
          text: "Etiquetas",
          icon: "fas fa-tags",
          id: 11,
          router: `/gestionEmpleados/info/${localStorage.getItem(
            "empId"
          )}/Etiquetas`,
        },
        {
          text: "Permisos",
          icon: "mdi-account-cog",
          id: 12,
          router: `/gestionEmpleados/info/${localStorage.getItem(
            "empId"
          )}/Permisos`,
        },
      ],
    };
  },
};
</script>
